export var defaultCalendar = {
    sameDay: '[Today at] LT',
    nextDay: '[Tomorrow at] LT',
    nextWeek: 'dddd [at] LT',
    lastDay: '[Yesterday at] LT',
    lastWeek: '[Last] dddd [at] LT',
    sameElse: 'L'
};
//# sourceMappingURL=calendar.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/chronos/locale/calendar.js
// module id = 485
// module chunks = 3